/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Validate timestamps of an uploaded file.
 * @export
 * @interface FileMeta
 */
export interface FileMeta {
  /**
   *
   */
  valuesReference?: string;
  /**
   *
   */
  units?: string;
  /**
   * seconds in the simulation
   */
  timestamps?: Array<number>;
  /**
   * seconds in the simulation
   */
  offset?: number;
  /**
   * seconds
   */
  duration?: number;
  /**
   *
   */
  geotransform?: Array<number>;
  /**
   *
   */
  epsgCode?: number;
  /**
   *
   */
  interval?: number;
  /**
   *
   */
  error?: string;
  /**
   *
   */
  fillValue?: string;
}

/**
 * Check if a given object implements the FileMeta interface.
 */
export function instanceOfFileMeta(value: object): value is FileMeta {
  return true;
}

export function FileMetaFromJSON(json: any): FileMeta {
  return FileMetaFromJSONTyped(json, false);
}

export function FileMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileMeta {
  if (json == null) {
    return json;
  }
  return {
    valuesReference: json["values_reference"] == null ? undefined : json["values_reference"],
    units: json["units"] == null ? undefined : json["units"],
    timestamps: json["timestamps"] == null ? undefined : json["timestamps"],
    offset: json["offset"] == null ? undefined : json["offset"],
    duration: json["duration"] == null ? undefined : json["duration"],
    geotransform: json["geotransform"] == null ? undefined : json["geotransform"],
    epsgCode: json["epsg_code"] == null ? undefined : json["epsg_code"],
    interval: json["interval"] == null ? undefined : json["interval"],
    error: json["error"] == null ? undefined : json["error"],
    fillValue: json["fill_value"] == null ? undefined : json["fill_value"],
  };
}

export function FileMetaToJSON(json: any): FileMeta {
  return FileMetaToJSONTyped(json, false);
}

export function FileMetaToJSONTyped(
  value?: FileMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    values_reference: value["valuesReference"],
    units: value["units"],
    timestamps: value["timestamps"],
    offset: value["offset"],
    duration: value["duration"],
    geotransform: value["geotransform"],
    epsg_code: value["epsgCode"],
    interval: value["interval"],
    error: value["error"],
    fill_value: value["fillValue"],
  };
}
